/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponsePagedResultRecharge } from '../models/api-response-paged-result-recharge';
import { ApiResponseRecharge } from '../models/api-response-recharge';
import { createRecharge } from '../fn/recharge-api/create-recharge';
import { CreateRecharge$Params } from '../fn/recharge-api/create-recharge';
import { getRechargeByReference } from '../fn/recharge-api/get-recharge-by-reference';
import { GetRechargeByReference$Params } from '../fn/recharge-api/get-recharge-by-reference';
import { searchRecharges } from '../fn/recharge-api/search-recharges';
import { SearchRecharges$Params } from '../fn/recharge-api/search-recharges';
import { updateRecharge } from '../fn/recharge-api/update-recharge';
import { UpdateRecharge$Params } from '../fn/recharge-api/update-recharge';

@Injectable({ providedIn: 'root' })
export class RechargeApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRechargeByReference()` */
  static readonly GetRechargeByReferencePath = '/v1/api/ui/meta-pricing-analytics/recharge/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRechargeByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRechargeByReference$Response(params: GetRechargeByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseRecharge>> {
    return getRechargeByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRechargeByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRechargeByReference(params: GetRechargeByReference$Params, context?: HttpContext): Observable<ApiResponseRecharge> {
    return this.getRechargeByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseRecharge>): ApiResponseRecharge => r.body)
    );
  }

  /** Path part for operation `updateRecharge()` */
  static readonly UpdateRechargePath = '/v1/api/ui/meta-pricing-analytics/recharge/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRecharge()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRecharge$Response(params: UpdateRecharge$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseRecharge>> {
    return updateRecharge(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRecharge$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRecharge(params: UpdateRecharge$Params, context?: HttpContext): Observable<ApiResponseRecharge> {
    return this.updateRecharge$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseRecharge>): ApiResponseRecharge => r.body)
    );
  }

  /** Path part for operation `createRecharge()` */
  static readonly CreateRechargePath = '/v1/api/ui/meta-pricing-analytics/recharge';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRecharge()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRecharge$Response(params: CreateRecharge$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseRecharge>> {
    return createRecharge(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRecharge$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRecharge(params: CreateRecharge$Params, context?: HttpContext): Observable<ApiResponseRecharge> {
    return this.createRecharge$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseRecharge>): ApiResponseRecharge => r.body)
    );
  }

  /** Path part for operation `searchRecharges()` */
  static readonly SearchRechargesPath = '/v1/api/ui/meta-pricing-analytics/recharge/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchRecharges()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchRecharges$Response(params: SearchRecharges$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultRecharge>> {
    return searchRecharges(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchRecharges$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchRecharges(params: SearchRecharges$Params, context?: HttpContext): Observable<ApiResponsePagedResultRecharge> {
    return this.searchRecharges$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultRecharge>): ApiResponsePagedResultRecharge => r.body)
    );
  }

}
